import { Button, Dialog, DialogContent, DialogTitle } from '@e2n/ui';
import { toast } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useZugangLoeschen } from '../hooks/useZugangLoeschen.ts';

type LoeschenDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  uidZugang: string;
};

export function LoeschenDialog({
  open,
  onOpenChange,
  uidZugang,
}: LoeschenDialogProps) {
  const { t } = useTranslation();
  const { loescheZugang, loading } = useZugangLoeschen(uidZugang);

  async function handleConfirm() {
    if (await loescheZugang()) {
      onOpenChange(false);
      return;
    }

    toast({
      variant: 'error',
      title: t('domain.e2nApi.zugaenge.loeschenDialog.fehler'),
    });
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-6 p-8 sm:max-w-[444px]">
        <DialogTitle>
          {t('domain.e2nApi.zugaenge.loeschenDialog.title')}
        </DialogTitle>

        <div className="text-sm text-neutrals-900">
          {t('domain.e2nApi.zugaenge.loeschenDialog.description')}
        </div>

        <div className="flex items-center justify-end gap-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('domain.e2nApi.zugaenge.loeschenDialog.abbrechen')}
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={loading}>
            {t('domain.e2nApi.zugaenge.loeschenDialog.bestaetigen')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
